import React, { useState } from 'react';
import SharedFooter from './components/SharedFooter';
import './App.css';

function Reveal({ children }) {
  return children;
}

/* ── Hero ────────────────────────────────────────────── */
function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-7 pt-[120px] pb-20 overflow-hidden bg-[#05050f]">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
      <div className="hero-grid" />

      <div className="hero-inner">
        {/* ── Left: text + store buttons ── */}
        <div className="hero-text-col">
          <div className="inline-flex items-center gap-2.5 bg-[rgba(99,102,241,0.1)] border border-[rgba(99,102,241,0.25)] px-[18px] py-2 rounded-full text-[13px] font-semibold text-indigo-300 mb-6 cursor-pointer">
            <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] text-white text-[10px] font-black px-[9px] py-0.5 rounded-full uppercase tracking-wider">New</span>
            AI-powered job matching is here →
          </div>

          <h1 className="text-[clamp(40px,7vw,84px)] font-black leading-[1.04] tracking-[-0.045em] mb-6 text-[#f1f1ff]">
            Your dream career<br />
            <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">starts right here.</span>
          </h1>

          <p className="text-[18px] text-[#8888bb] max-w-[500px] leading-[1.7]">
            Students find internships &amp; first jobs. Recruiters find top talent.
            tryBinC's AI matches the right people to the right roles — instantly.
          </p>

          {/* Store download buttons */}
          <div className="flex gap-3.5 flex-wrap mt-9">
            <a
              href="https://play.google.com/store/apps/details?id=com.trybinc.jobs"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.14)] rounded-[13px] px-[22px] py-3 text-[#f1f1ff] no-underline backdrop-blur-sm transition-all hover:bg-[rgba(255,255,255,0.1)] hover:border-[rgba(99,102,241,0.5)] hover:shadow-[0_8px_28px_rgba(99,102,241,0.2)]"
            >
              <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.424 0.403C0.157 0.683 0 1.11 0 1.663V22.34c0 .553.157.98.424 1.26l.067.065L11.87 12.2v-.273L.49.337.424.403z" fill="url(#gp_a)"/>
                <path d="M15.828 16.073L11.87 12.2v-.273l3.96-3.873.09.05 4.69 2.665c1.34.762 1.34 2.008 0 2.77l-4.69 2.665-.092-.13z" fill="url(#gp_b)"/>
                <path d="M15.92 15.94L11.87 11.99.424 23.6c.44.467 1.17.524 1.985.059L15.92 15.94z" fill="url(#gp_c)"/>
                <path d="M15.92 8.06L2.41.342C1.593-.124.863-.066.424.4l11.446 11.59L15.92 8.06z" fill="url(#gp_d)"/>
                <defs>
                  <linearGradient id="gp_a" x1="10.8" y1="1.374" x2="-4.61" y2="16.784" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00A0FF"/><stop offset=".007" stopColor="#00A1FF"/>
                    <stop offset=".26" stopColor="#00BEFF"/><stop offset=".512" stopColor="#00D2FF"/>
                    <stop offset=".76" stopColor="#00DFFF"/><stop offset="1" stopColor="#00E3FF"/>
                  </linearGradient>
                  <linearGradient id="gp_b" x1="21.6" y1="11.99" x2="-.33" y2="11.99" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE000"/><stop offset=".409" stopColor="#FFBD00"/>
                    <stop offset=".775" stopColor="#FFA500"/><stop offset="1" stopColor="#FF9C00"/>
                  </linearGradient>
                  <linearGradient id="gp_c" x1="13.6" y1="14.01" x2="-7.38" y2="34.99" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF3A44"/><stop offset="1" stopColor="#C31162"/>
                  </linearGradient>
                  <linearGradient id="gp_d" x1="-1.99" y1="-8.05" x2="8.43" y2="2.37" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A071"/><stop offset=".069" stopColor="#2DA771"/>
                    <stop offset=".476" stopColor="#15CF74"/><stop offset=".801" stopColor="#06E775"/>
                    <stop offset="1" stopColor="#00F076"/>
                  </linearGradient>
                </defs>
              </svg>
              <div className="flex flex-col leading-[1.2]">
                <span className="text-[10px] text-[rgba(255,255,255,0.55)] font-medium tracking-[0.03em]">Get it on</span>
                <span className="text-[16px] font-extrabold tracking-[-0.02em]">Google Play</span>
              </div>
            </a>

            <a href="#0" className="flex items-center gap-3 bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.14)] rounded-[13px] px-[22px] py-3 text-[#f1f1ff] no-underline backdrop-blur-sm transition-all hover:bg-[rgba(255,255,255,0.1)] hover:border-[rgba(99,102,241,0.5)] hover:shadow-[0_8px_28px_rgba(99,102,241,0.2)]">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="flex flex-col leading-[1.2]">
                <span className="text-[10px] text-[rgba(255,255,255,0.55)] font-medium tracking-[0.03em]">Download on the</span>
                <span className="text-[16px] font-extrabold tracking-[-0.02em]">App Store</span>
              </div>
            </a>
          </div>

          <p className="text-[12.5px] text-[#8888bb] mt-3.5">Free to download · Available on iOS &amp; Android</p>
        </div>

        {/* ── Right: phone mockup ── */}
        <div className="hero-phone-col">
          <div className="phone-glow" />
          <div className="phone-shell">
            <div className="phone-ring" />
            <div className="phone-btn phone-btn-vol-up" />
            <div className="phone-btn phone-btn-vol-dn" />
            <div className="phone-btn phone-btn-power" />
            <div className="phone-screen">
              <div className="phone-island" />
              <img src="/mockup_bg.jpg" alt="tryBinC app" className="phone-screen-img" fetchpriority="high" />
              <div className="phone-glare" />
              <div className="phone-statusbar" />
            </div>
            <div className="phone-home-bar" />
          </div>

          <div className="phone-badge phone-badge-left">
            <span className="text-[22px] flex-shrink-0">💼</span>
            <div>
              <div className="text-[13.5px] font-extrabold leading-[1.2]">12,400+</div>
              <div className="text-[11.5px] text-[#8888bb]">Jobs live</div>
            </div>
          </div>

          <div className="phone-badge phone-badge-right">
            <span className="text-[22px] flex-shrink-0">🤖</span>
            <div>
              <div className="text-[13.5px] font-extrabold leading-[1.2]">94% match</div>
              <div className="text-[11.5px] text-[#8888bb]">AI score</div>
            </div>
          </div>

          <div className="phone-badge phone-badge-bottom">
            <span className="text-[22px] flex-shrink-0">🎉</span>
            <div className="text-[12px] font-semibold text-[#f1f1ff]">
              Offer received from <strong>Stripe</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── Logos ───────────────────────────────────────────── */
const LOGOS = ['Google', 'Stripe', 'Airbnb', 'Figma', 'Notion', 'Shopify', 'Linear'];

function Logos() {
  return (
    <section className="py-[52px] px-7 border-t border-b border-[rgba(99,102,241,0.15)] bg-[#0a0a1e] text-center">
      <Reveal>
        <p className="text-[11.5px] uppercase tracking-[0.13em] text-[#8888bb] mb-6">50,000+ companies hiring on tryBinC</p>
      </Reveal>
      <div className="flex justify-center items-center gap-[52px] flex-wrap">
        {LOGOS.map(name => (
          <span key={name} className="text-[17px] font-extrabold tracking-[-0.03em] text-[#8888bb] opacity-50">{name}</span>
        ))}
      </div>
    </section>
  );
}

/* ── Dual Audience ───────────────────────────────────── */
function DualAudience() {
  return (
    <section className="py-[110px] px-7">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="text-center">
            <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">👥 &nbsp;Who it's for</div>
            <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Built for students <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">&</span> recruiters</h2>
            <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">Whether you're launching your career or building your team — tryBinC is designed for you.</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-[60px]">
          <div className="dual-card students">
            <div className="text-5xl mb-4">🎓</div>
            <h3 className="text-[26px] font-extrabold tracking-[-0.03em] mb-2.5"><span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">For Students</span></h3>
            <p className="text-[15px] text-[#8888bb] leading-[1.7] mb-7">Land your first internship or full-time role with AI-guided applications, resume feedback, and personalized job matches.</p>
            <ul className="list-none mb-8 flex flex-col gap-2.5">
              {[
                'AI resume builder & keyword optimizer',
                'Internship & entry-level job discovery',
                'One-click apply to 10,000+ roles',
                'Interview prep & mock tests',
                'Track all your applications in one place',
              ].map(item => (
                <li key={item} className="text-[14px] text-[#8888bb] flex items-center gap-2.5">
                  <span className="w-5 h-5 rounded-[6px] flex-shrink-0 flex items-center justify-center text-[11px] font-extrabold bg-[rgba(99,102,241,0.2)] text-indigo-300">✓</span>{item}
                </li>
              ))}
            </ul>
            <button className="border-none rounded-[10px] px-7 py-3 text-[14px] font-bold cursor-pointer transition-all hover:opacity-[0.88] hover:-translate-y-0.5 bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] text-white">Find Jobs as a Student →</button>
          </div>

          <div className="dual-card recruiters">
            <div className="text-5xl mb-4">🏢</div>
            <h3 className="text-[26px] font-extrabold tracking-[-0.03em] mb-2.5"><span className="bg-gradient-to-r from-[#06b6d4] to-[#6366f1] bg-clip-text text-transparent">For Recruiters</span></h3>
            <p className="text-[15px] text-[#8888bb] leading-[1.7] mb-7">Source, screen, and hire top candidates faster than ever. AI ranking and an ATS-ready pipeline mean less admin and more great hires.</p>
            <ul className="list-none mb-8 flex flex-col gap-2.5">
              {[
                'Post jobs to 50+ boards in one click',
                'AI candidate scoring & ranking',
                'Smart applicant tracking system',
                'Automated outreach & scheduling',
                'Live analytics & hiring dashboards',
              ].map(item => (
                <li key={item} className="text-[14px] text-[#8888bb] flex items-center gap-2.5">
                  <span className="w-5 h-5 rounded-[6px] flex-shrink-0 flex items-center justify-center text-[11px] font-extrabold bg-[rgba(6,182,212,0.2)] text-cyan-300">✓</span>{item}
                </li>
              ))}
            </ul>
            <button className="border-none rounded-[10px] px-7 py-3 text-[14px] font-bold cursor-pointer transition-all hover:opacity-[0.88] hover:-translate-y-0.5 bg-gradient-to-r from-[#06b6d4] to-[#6366f1] text-white">Start Hiring Today →</button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── Job Categories ──────────────────────────────────── */
const CATEGORIES = [
  { icon: '💻', name: 'Engineering', count: '12,400 jobs' },
  { icon: '🎨', name: 'Design', count: '4,200 jobs' },
  { icon: '📊', name: 'Data & AI', count: '7,800 jobs' },
  { icon: '📣', name: 'Marketing', count: '5,100 jobs' },
  { icon: '💼', name: 'Finance', count: '3,900 jobs' },
  { icon: '🩺', name: 'Healthcare', count: '6,300 jobs' },
  { icon: '⚖️', name: 'Legal', count: '1,700 jobs' },
  { icon: '🎓', name: 'Education', count: '2,800 jobs' },
  { icon: '🛒', name: 'Sales', count: '4,500 jobs' },
  { icon: '🔧', name: 'Operations', count: '3,200 jobs' },
];

function Categories() {
  return (
    <section className="py-[100px] px-7 bg-[#0a0a1e] text-center">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">🗂️ &nbsp;Explore by Category</div>
          <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Browse <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">50,000+</span> open roles</h2>
          <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">From tech to healthcare, find opportunities in every industry.</p>
        </Reveal>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-4 mt-[52px]">
          {CATEGORIES.map(c => (
            <div key={c.name} className="bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-2xl p-7 text-center cursor-pointer transition-all duration-200 hover:border-[rgba(99,102,241,0.3)] hover:-translate-y-1 hover:bg-[#14143a]">
              <div className="text-[28px] mb-2.5">{c.icon}</div>
              <div className="text-[13px] font-bold mb-1 text-[#f1f1ff]">{c.name}</div>
              <div className="text-[11.5px] text-[#8888bb]">{c.count}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── How it works ────────────────────────────────────── */
const HOW_STEPS = [
  { n: '01', emoji: '📝', title: 'Create your profile', desc: 'Build a standout profile in minutes. Upload your resume or let our AI generate one from scratch.' },
  { n: '02', emoji: '🤖', title: 'AI finds your matches', desc: 'Our engine analyzes your skills, interests, and goals to surface the most relevant opportunities instantly.' },
  { n: '03', emoji: '🚀', title: 'Apply in one click', desc: 'Send applications to multiple companies without re-entering your details. Track status in real time.' },
  { n: '04', emoji: '🎉', title: 'Land the offer', desc: 'Prep with mock interviews, negotiate confidently, and celebrate landing your next great role.' },
];

function HowItWorks() {
  return (
    <section className="py-[110px] px-7 text-center">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">⚙️ &nbsp;How it works</div>
          <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Get hired in <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">4 easy steps</span></h2>
          <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">The fastest path from student to employed — no fluff, just results.</p>
        </Reveal>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(230px,1fr))] gap-0 mt-16 relative">
          <div className="absolute top-9 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[rgba(99,102,241,0.3)] to-transparent pointer-events-none hidden md:block" />
          {HOW_STEPS.map(s => (
            <div key={s.n} className="px-6 relative">
              <div className="w-[72px] h-[72px] rounded-full flex items-center justify-center text-[22px] mx-auto mb-5 bg-gradient-to-br from-[#6366f1] via-[#8b5cf6] to-[#d946ef] shadow-[0_0_0_8px_rgba(99,102,241,0.1),0_0_32px_rgba(99,102,241,0.3)]">{s.emoji}</div>
              <h3 className="text-[17px] font-extrabold mb-2 text-[#f1f1ff]">{s.title}</h3>
              <p className="text-[13.5px] text-[#8888bb] leading-[1.7]">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── Features ────────────────────────────────────────── */
const FEATURES = [
  { icon: '🤖', title: 'AI-Powered Matching',    desc: 'Proprietary ML models analyze 50+ signals — skills, culture fit, growth stage — to rank your best-fit roles or candidates.' },
  { icon: '📊', title: 'Real-Time Analytics',    desc: 'Recruiters get live dashboards for pipeline health, source ROI, and time-to-hire. Students track application open rates.' },
  { icon: '📋', title: '50+ Job Boards',          desc: 'Publish once, distribute everywhere. Manage all inbound applications from a single unified inbox with smart filters.' },
  { icon: '🎯', title: 'Resume AI Optimizer',    desc: 'Students get instant ATS keyword scores and one-click suggestions to improve their resume for each specific role.' },
  { icon: '🗓️', title: 'Automated Scheduling',  desc: 'Interview booking links, automated reminders, and calendar sync mean zero back-and-forth email chains.' },
  { icon: '🔒', title: 'Enterprise Security',   desc: 'SOC 2 Type II certified. GDPR-ready. SSO + role-based access. Trusted by Fortune 500 recruiting teams.' },
];

function Features() {
  return (
    <section className="py-[110px] px-7 text-center">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">⚡ &nbsp;Platform Features</div>
          <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Everything you need to <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">hire or get hired</span></h2>
          <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">One platform that works powerfully for both sides of the hiring equation.</p>
        </Reveal>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5 mt-14 text-left">
          {FEATURES.map(f => (
            <div key={f.title} className="feature-card bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-2xl p-8 cursor-default transition-all duration-300 hover:border-[rgba(99,102,241,0.3)] hover:-translate-y-0.5">
              <div className="w-[52px] h-[52px] bg-[rgba(99,102,241,0.15)] rounded-[14px] flex items-center justify-center text-2xl mb-[18px]">{f.icon}</div>
              <h3 className="text-[18px] font-extrabold mb-2 tracking-[-0.02em] text-[#f1f1ff]">{f.title}</h3>
              <p className="text-[14px] text-[#8888bb] leading-[1.75]">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── Stats ───────────────────────────────────────────── */
const STATS = [
  { value: '3M+',  label: 'Students & job seekers' },
  { value: '50K+', label: 'Companies hiring now' },
  { value: '4x',   label: 'Faster time-to-hire' },
  { value: '98%',  label: 'Satisfaction rate' },
];

function Stats() {
  return (
    <section className="py-[90px] px-7 bg-gradient-to-br from-[rgba(99,102,241,0.1)] via-[rgba(139,92,246,0.06)] to-[rgba(217,70,239,0.08)] border-t border-b border-[rgba(99,102,241,0.15)]">
      <div className="max-w-[1160px] mx-auto px-7">
        <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-10 text-center">
          {STATS.map(s => (
            <div key={s.label}>
              <div className="text-[clamp(40px,5.5vw,62px)] font-black tracking-[-0.05em] bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">{s.value}</div>
              <div className="text-[14px] text-[#8888bb] mt-1.5 font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── Skill Hub ───────────────────────────────────────── */
const SKILL_TRACKS = [
  { id: 'webdev',    icon: '💻', name: 'Web Development',   courses: 84, level: 'Beginner → Advanced', color: '#6366f1', bg: 'rgba(99,102,241,0.12)',  border: 'rgba(99,102,241,0.28)'  },
  { id: 'data',      icon: '📊', name: 'Data Science',      courses: 62, level: 'Intermediate',        color: '#06b6d4', bg: 'rgba(6,182,212,0.12)',   border: 'rgba(6,182,212,0.28)'   },
  { id: 'uiux',      icon: '🎨', name: 'UI/UX Design',      courses: 47, level: 'Beginner',            color: '#d946ef', bg: 'rgba(217,70,239,0.12)', border: 'rgba(217,70,239,0.28)'  },
  { id: 'marketing', icon: '📣', name: 'Digital Marketing', courses: 55, level: 'Beginner',            color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.28)'  },
  { id: 'devops',    icon: '☁️', name: 'Cloud & DevOps',    courses: 39, level: 'Intermediate → Advanced', color: '#10b981', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.28)' },
  { id: 'business',  icon: '💼', name: 'Business & Finance',courses: 51, level: 'Beginner',            color: '#f43f5e', bg: 'rgba(244,63,94,0.12)',  border: 'rgba(244,63,94,0.28)'   },
];

const FEATURED_SESSIONS = [
  { id: 'react', gradientBg: 'linear-gradient(135deg,#6366f1 0%,#8b5cf6 100%)', thumbEmoji: '⚛️', title: 'React & Next.js Bootcamp', instructor: 'Arjun Mehta', instructorInitials: 'AM', instructorColor: '#6366f1', duration: '12h 30m', level: 'Intermediate', levelColor: '#8b5cf6', enrolled: '8,240', tag: 'POPULAR', tagColor: '#f59e0b' },
  { id: 'python', gradientBg: 'linear-gradient(135deg,#06b6d4 0%,#6366f1 100%)', thumbEmoji: '🐍', title: 'Python for Machine Learning', instructor: 'Priya Rao', instructorInitials: 'PR', instructorColor: '#06b6d4', duration: '18h 45m', level: 'Beginner', levelColor: '#10b981', enrolled: '12,100', tag: 'NEW', tagColor: '#10b981' },
  { id: 'figma', gradientBg: 'linear-gradient(135deg,#d946ef 0%,#f43f5e 100%)', thumbEmoji: '🖌️', title: 'Figma to Full UX Case Study', instructor: 'Sara Kim', instructorInitials: 'SK', instructorColor: '#d946ef', duration: '9h 15m', level: 'Advanced', levelColor: '#f43f5e', enrolled: '4,890', tag: 'TRENDING', tagColor: '#d946ef' },
];

const SKILL_HUB_STATS = [
  { value: '500+',  label: 'Courses' },
  { value: '200+',  label: 'Mentors' },
  { value: '50K+',  label: 'Students Enrolled' },
  { value: '4.8★',  label: 'Average Rating' },
];

const MENTOR_AVATARS = [
  { initials: 'AM', color: '#6366f1' },
  { initials: 'PR', color: '#06b6d4' },
  { initials: 'SK', color: '#d946ef' },
  { initials: 'RN', color: '#10b981' },
  { initials: 'VK', color: '#f59e0b' },
];

function SkillHub() {
  return (
    <section className="py-[110px] px-7 bg-[#0a0a1e] border-t border-[rgba(99,102,241,0.15)] text-center">
      <div className="max-w-[1160px] mx-auto px-7">

        <Reveal>
          <div className="text-center">
            <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">🎓 &nbsp;Skill Hub</div>
            <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">
              Level up your skills,{' '}
              <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">land your dream job</span>
            </h2>
            <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">
              Industry-crafted training tracks and live career guidance from professionals who've been where you're going.
            </p>
          </div>
        </Reveal>

        {/* Training Tracks */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-[18px] mt-14 text-left">
          {SKILL_TRACKS.map(track => (
            <div
              key={track.id}
              className="sh-track-card"
              style={{ background: track.bg, borderColor: track.border }}
            >
              <div className="w-14 h-14 rounded-[14px] flex items-center justify-center flex-shrink-0" style={{ background: track.bg, border: `1px solid ${track.border}` }}>
                <span style={{ fontSize: 26 }}>{track.icon}</span>
              </div>
              <div className="flex-1 flex flex-col gap-2">
                <div className="text-[17px] font-extrabold tracking-[-0.025em] text-[#f1f1ff] leading-[1.2]">{track.name}</div>
                <div className="flex items-center gap-2.5 flex-wrap">
                  <span className="text-[12.5px] text-[#8888bb] font-medium">{track.courses} courses</span>
                  <span className="text-[10.5px] font-bold uppercase tracking-[0.07em] px-2.5 py-[3px] rounded-full border" style={{ color: track.color, background: track.bg, borderColor: track.border }}>
                    {track.level}
                  </span>
                </div>
              </div>
              <div className="sh-track-enroll" style={{ background: track.color }}>
                Enroll →
              </div>
            </div>
          ))}
        </div>

        {/* Featured Sessions */}
        <Reveal delay={0.08}>
          <div className="flex items-center justify-between mt-[72px] mb-7">
            <h3 className="text-[22px] font-extrabold tracking-[-0.03em] text-left text-[#f1f1ff]">Featured Sessions</h3>
            <button className="bg-none border border-[rgba(99,102,241,0.3)] text-indigo-300 text-[13px] font-semibold px-[18px] py-2 rounded-lg cursor-pointer font-sans transition-all hover:bg-[rgba(99,102,241,0.1)] hover:border-[#6366f1] whitespace-nowrap">See all courses →</button>
          </div>
        </Reveal>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5">
          {FEATURED_SESSIONS.map(s => (
            <div key={s.id} className="bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-[20px] overflow-hidden text-left cursor-pointer transition-all hover:border-[rgba(99,102,241,0.3)]">
              <div className="h-[148px] relative flex items-center justify-center" style={{ background: s.gradientBg }}>
                <span className="text-[52px] leading-[1] drop-shadow-[0_4px_16px_rgba(0,0,0,0.5)]">{s.thumbEmoji}</span>
                <span className="absolute top-3 right-3 text-[9.5px] font-black uppercase tracking-[0.1em] text-white px-2.5 py-[3px] rounded-full" style={{ background: s.tagColor }}>{s.tag}</span>
              </div>
              <div className="p-5 flex flex-col gap-3">
                <div className="text-[16px] font-extrabold tracking-[-0.02em] leading-[1.3] text-[#f1f1ff]">{s.title}</div>
                <div className="flex items-center gap-2.5">
                  <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-extrabold text-white flex-shrink-0" style={{ background: s.instructorColor }}>{s.instructorInitials}</div>
                  <span className="text-[13px] text-[#8888bb] font-medium">{s.instructor}</span>
                </div>
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="text-[12.5px] text-[#8888bb] font-medium">⏱ {s.duration}</span>
                  <span className="text-[12px] font-bold" style={{ color: s.levelColor }}>{s.level}</span>
                  <span className="text-[12.5px] text-[#8888bb] font-medium">👥 {s.enrolled}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Career Guidance Banner */}
        <Reveal delay={0.05}>
          <div className="mt-[72px] bg-gradient-to-br from-[rgba(99,102,241,0.14)] via-[rgba(139,92,246,0.08)] to-[rgba(217,70,239,0.1)] border border-[rgba(99,102,241,0.28)] rounded-[28px] p-[52px] grid grid-cols-1 md:grid-cols-[1fr_minmax(0,320px)] gap-12 items-center text-left relative overflow-hidden">
            <div className="absolute -top-20 -left-20 w-[300px] h-[300px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(99,102,241,0.22) 0%, transparent 70%)' }} />
            <div>
              <div className="text-[42px] mb-2.5">🧭</div>
              <h3 className="text-[clamp(22px,3vw,30px)] font-black tracking-[-0.035em] mb-3 leading-[1.15] bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">1-on-1 Career Guidance</h3>
              <p className="text-[15px] text-[#8888bb] leading-[1.75] max-w-[480px] mb-5">
                Book private sessions with industry mentors — engineers, designers, and product leaders from top companies — who will help you navigate your career path.
              </p>
              <ul className="list-none flex flex-col gap-2.5 mb-7">
                {['Resume & portfolio deep-dives', 'Mock interviews with real feedback', 'Salary negotiation coaching', 'Career roadmap & goal setting'].map(item => (
                  <li key={item} className="text-[14px] text-[#8888bb] flex items-center gap-2.5">
                    <span className="w-5 h-5 rounded-[6px] bg-[rgba(99,102,241,0.2)] text-indigo-300 inline-flex items-center justify-center text-[11px] font-extrabold flex-shrink-0">✓</span>{item}
                  </li>
                ))}
              </ul>
              <button className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] text-white border-none px-7 py-3 rounded-[10px] text-[14.5px] font-bold cursor-pointer font-sans transition-all hover:opacity-[0.88] hover:shadow-[0_10px_32px_rgba(99,102,241,0.35)]">Book a Free Session →</button>
            </div>

            <div className="flex flex-col items-center gap-[18px]">
              <div className="flex items-center">
                {MENTOR_AVATARS.map((m, i) => (
                  <div
                    key={m.initials}
                    className="w-[50px] h-[50px] rounded-full flex items-center justify-center text-[14px] font-extrabold text-white border-[2.5px] border-[#0a0a1e] cursor-default transition-transform hover:scale-110"
                    style={{ background: m.color, zIndex: MENTOR_AVATARS.length - i, marginLeft: i === 0 ? 0 : -14 }}
                  >
                    {m.initials}
                  </div>
                ))}
              </div>
              <div className="text-[13px] text-[#8888bb] font-medium">200+ verified mentors</div>
              <div className="flex gap-3 flex-wrap justify-center w-full">
                {[{ value: '18K+', label: 'Sessions held' }, { value: '4.9★', label: 'Avg. rating' }, { value: '< 2h', label: 'Response time' }].map(s => (
                  <div key={s.label} className="bg-[rgba(255,255,255,0.04)] border border-[rgba(99,102,241,0.15)] rounded-[14px] px-4 py-3.5 text-center flex-1 min-w-[80px]">
                    <div className="text-[22px] font-black tracking-[-0.04em] leading-[1.1] bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">{s.value}</div>
                    <div className="text-[11px] text-[#8888bb] font-medium mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>

        {/* Mini Stats Bar */}
        <div className="grid grid-cols-4 mt-14 bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-[20px] overflow-hidden">
          {SKILL_HUB_STATS.map((s, idx) => (
            <div key={s.label} className={`px-6 py-7 text-center flex flex-col gap-1 ${idx < SKILL_HUB_STATS.length - 1 ? 'border-r border-[rgba(99,102,241,0.15)]' : ''}`}>
              <span className="text-[clamp(26px,3vw,36px)] font-black tracking-[-0.04em] leading-[1.1] bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">{s.value}</span>
              <span className="text-[13px] text-[#8888bb] font-medium">{s.label}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

/* ── Testimonials ────────────────────────────────────── */
const TESTIMONIALS = [
  { text: '"I applied to 3 jobs via tryBinC on Monday. By Friday I had 2 interviews lined up. The AI match score was spot on — every role felt tailor-made for me."', name: 'Aisha Patel', role: 'CS Graduate → SWE @ Stripe', initials: 'AP', color: '#6366f1', type: '🎓 Student' },
  { text: '"We posted a senior role and tryBinC had 5 pre-screened candidates in our inbox within hours. We made a hire 3 weeks faster than our usual process."', name: 'Marcus Chen', role: 'Head of Engineering @ Linear', initials: 'MC', color: '#06b6d4', type: '🏢 Recruiter' },
  { text: '"The resume optimizer alone is worth it. My interview rate jumped from 6% to 34% after I ran my CV through tryBinC\'s AI suggestions."', name: 'Jordan Lee', role: 'MBA Student → PM @ Notion', initials: 'JL', color: '#d946ef', type: '🎓 Student' },
  { text: '"Replaced two separate tools (job board + ATS) with tryBinC. The unified pipeline has made our 4-person recruiting team feel like 8."', name: 'Priya Singh', role: 'Talent Lead @ Vercel', initials: 'PS', color: '#10b981', type: '🏢 Recruiter' },
];

function Testimonials() {
  return (
    <section className="py-[110px] px-7 bg-[#0a0a1e] text-center">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">💬 &nbsp;Success Stories</div>
          <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Real people, <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">real results</span></h2>
          <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">Students and recruiters both love what tryBinC does for them.</p>
        </Reveal>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5 mt-14 text-left">
          {TESTIMONIALS.map(t => (
            <div key={t.name} className="bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-[20px] p-[30px] transition-all hover:border-[rgba(99,102,241,0.3)] hover:-translate-y-0.5">
              <div className="text-[#fbbf24] text-[14px] mb-3.5 tracking-[2px]">★★★★★</div>
              <p className="text-[15px] text-[#f1f1ff] leading-[1.75] mb-5 italic">{t.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-[42px] h-[42px] rounded-full flex items-center justify-center text-[15px] font-extrabold text-white flex-shrink-0" style={{ background: t.color }}>{t.initials}</div>
                <div>
                  <div className="text-[14px] font-bold text-[#f1f1ff]">{t.name}</div>
                  <div className="text-[12px] text-[#8888bb]">{t.role}</div>
                </div>
                <span className="ml-auto text-[11px] bg-[#14143a] border border-[rgba(99,102,241,0.15)] rounded-full px-2.5 py-[3px] text-[#8888bb] whitespace-nowrap">
                  {t.type}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── Problem / Solution ──────────────────────────────── */
const STUDENT_PAINS = [
  { icon: '😩', title: 'Endless job searching', desc: 'Scrolling through hundreds of irrelevant listings wastes hours every day.' },
  { icon: '📄', title: 'Resume black hole', desc: 'Sending resumes into the void with zero feedback or response rates.' },
  { icon: '🤷', title: 'No clear direction', desc: 'Not knowing which roles fit your skills or how to stand out from 500 applicants.' },
];
const RECRUITER_PAINS = [
  { icon: '📥', title: 'Application overload', desc: 'Drowning in unqualified applicants makes it hard to spot real talent.' },
  { icon: '⏱️', title: 'Slow hiring cycles', desc: 'Manual screening and scheduling drags time-to-hire to 40+ days on average.' },
  { icon: '🔧', title: 'Too many tools', desc: 'Juggling job boards, ATS, and email threads creates a chaotic hiring process.' },
];

function PainPoints() {
  return (
    <section className="py-[100px] px-7 text-center">
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5">💡 &nbsp;The Problem We Solve</div>
          <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">Hiring is <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">broken.</span> We fix it.</h2>
          <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">Whether you're job hunting or talent hunting, the old way is frustrating and slow.</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-14">
          <div className="text-left">
            <h3 className="text-[20px] font-extrabold tracking-[-0.025em] mb-5 flex items-center gap-2.5 text-[#f1f1ff]"><span className="text-2xl">🎓</span> Students struggle with…</h3>
            {STUDENT_PAINS.map(p => (
              <div key={p.title} className="flex items-start gap-3.5 px-5 py-4 rounded-xl mb-3 bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] transition-all hover:border-[rgba(99,102,241,0.3)]">
                <div className="text-[20px] flex-shrink-0 mt-[1px]">{p.icon}</div>
                <div className="text-[14px] text-[#8888bb] leading-[1.6]"><strong className="text-[#f1f1ff] block text-[14px] mb-0.5">{p.title}</strong>{p.desc}</div>
              </div>
            ))}
          </div>

          <div className="text-left">
            <h3 className="text-[20px] font-extrabold tracking-[-0.025em] mb-5 flex items-center gap-2.5 text-[#f1f1ff]"><span className="text-2xl">🏢</span> Recruiters struggle with…</h3>
            {RECRUITER_PAINS.map(p => (
              <div key={p.title} className="flex items-start gap-3.5 px-5 py-4 rounded-xl mb-3 bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] transition-all hover:border-[rgba(99,102,241,0.3)]">
                <div className="text-[20px] flex-shrink-0 mt-[1px]">{p.icon}</div>
                <div className="text-[14px] text-[#8888bb] leading-[1.6]"><strong className="text-[#f1f1ff] block text-[14px] mb-0.5">{p.title}</strong>{p.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── FAQ ─────────────────────────────────────────────── */
const FAQS = [
  { q: 'Is tryBinC free for students?', a: 'Yes! The Student plan is free forever — unlimited applications, AI resume feedback, and basic job matching at no cost. Upgrade to Pro for advanced features like priority matching and mock interviews.' },
  { q: 'How does the AI matching work?', a: 'Our engine analyzes your skills, experience, location preference, and goals against real-time job data. It scores compatibility across 50+ signals so you only see roles you\'re genuinely suited for.' },
  { q: 'Can I post jobs without a credit card?', a: 'Absolutely. Recruiters get a full 14-day free trial — no credit card required. You can post jobs, receive applications, and test the ATS pipeline completely free before committing.' },
  { q: 'How is tryBinC different from LinkedIn or Indeed?', a: 'We\'re purpose-built for two-sided AI matching. Traditional job boards are glorified search engines. tryBinC actively ranks and surfaces the right fit for both sides — reducing noise and dramatically cutting time-to-hire.' },
  { q: 'Is my data safe?', a: 'Yes. We are SOC 2 Type II certified and GDPR compliant. Your data is encrypted at rest and in transit. We never sell your personal information to third parties.' },
];

function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <section className="py-[100px] px-7 bg-[#0a0a1e]">
      <div className="max-w-[1160px] mx-auto px-7">
        <div className="max-w-[760px] mx-auto text-center">
          <Reveal>
            <div className="inline-flex items-center gap-1.5 bg-[rgba(99,102,241,0.12)] border border-[rgba(99,102,241,0.25)] text-indigo-300 text-[11.5px] font-bold uppercase tracking-[0.09em] px-4 py-[5px] rounded-full mb-5 mx-auto">❓ &nbsp;FAQ</div>
            <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff] text-center">
              Got questions? <span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">We've got answers.</span>
            </h2>
          </Reveal>

          <div className="mt-[52px] flex flex-col gap-3 text-left">
            {FAQS.map((f, i) => (
              <Reveal key={f.q} delay={i * 0.07}>
                <div className="bg-[#0f0f26] border border-[rgba(99,102,241,0.15)] rounded-[14px] overflow-hidden transition-all hover:border-[rgba(99,102,241,0.3)]">
                  <button
                    className={`w-full bg-transparent border-none text-[#f1f1ff] px-6 py-5 text-[15px] font-bold text-left cursor-pointer flex justify-between items-center gap-4 font-sans`}
                    onClick={() => setOpen(open === i ? null : i)}
                  >
                    {f.q}
                    <span className={`text-[#6366f1] text-[18px] flex-shrink-0 transition-transform duration-200 ${open === i ? 'rotate-45' : ''}`}>+</span>
                  </button>
                  {open === i && <div className="px-6 pb-5 text-[14.5px] text-[#8888bb] leading-[1.75]">{f.a}</div>}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── CTA Banner ──────────────────────────────────────── */
function CTABanner() {
  return (
    <section className="py-[120px] px-7 text-center relative overflow-hidden">
      <div className="absolute w-[700px] h-[500px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(99,102,241,0.25) 0%, transparent 70%)' }} />
      <div className="max-w-[1160px] mx-auto px-7">
        <Reveal>
          <div className="relative z-[1] bg-gradient-to-br from-[rgba(99,102,241,0.15)] via-[rgba(139,92,246,0.08)] to-[rgba(217,70,239,0.12)] border border-[rgba(99,102,241,0.3)] rounded-[28px] py-[72px] px-12 max-w-[820px] mx-auto">
            <div className="text-[52px] mb-5">🚀</div>
            <h2 className="text-[clamp(28px,4.2vw,50px)] font-black leading-[1.1] tracking-[-0.035em] text-[#f1f1ff]">
              Ready to take the<br /><span className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] bg-clip-text text-transparent">next step?</span>
            </h2>
            <p className="text-[#8888bb] text-[17px] max-w-[580px] mx-auto mt-3.5">
              Students: start applying today — free forever.<br />
              Recruiters: post your first job in under 5 minutes.
            </p>
            <div className="flex gap-3.5 justify-center flex-wrap mt-9">
              <button className="bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#d946ef] text-white border-none py-[15px] px-9 rounded-[11px] text-[15px] font-bold cursor-pointer transition-all hover:opacity-[0.88] hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(99,102,241,0.4)]">Find My Dream Job</button>
              <button className="bg-transparent text-[#f1f1ff] border border-[rgba(99,102,241,0.3)] py-[15px] px-9 rounded-[11px] text-[15px] font-semibold cursor-pointer transition-all hover:border-[#6366f1] hover:bg-[rgba(99,102,241,0.08)] hover:-translate-y-0.5">Post a Job Free</button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}


/* ── App ─────────────────────────────────────────────── */
export default function App() {
  return (
    <>
      <Hero />
      <Logos />
      <DualAudience />
      <PainPoints />
      <Categories />
      <HowItWorks />
      <Features />
      <Stats />
      <SkillHub />
      {/* <Pricing /> */}
      <Testimonials />
      <FAQ />
      <CTABanner />
      <SharedFooter />
    </>
  );
}


